// extracted by mini-css-extract-plugin
export default {"ItemColors":"ItemColors_ItemColors__mtON2","itemPartColor":"ItemColors_itemPartColor__2TLsZ","color":"ItemColors_color__VPonC"};